import Layout from '@/layout';
var userRouter = {
  path: '/member',
  component: Layout,
  redirect: '/member/index',
  name: 'member',
  meta: {
    title: '会员',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/user/list/index');
    },
    name: 'UserIndex',
    meta: {
      title: '会员用户',
      icon: ''
    }
  }, {
    path: 'grade',
    component: function component() {
      return import('@/views/user/grade/index');
    },
    name: 'Grade',
    meta: {
      title: '会员等级',
      icon: ''
    }
  }, {
    path: 'label',
    component: function component() {
      return import('@/views/user/group/index');
    },
    name: 'Label',
    meta: {
      title: '会员标签',
      icon: ''
    }
  }, {
    path: 'group',
    component: function component() {
      return import('@/views/user/group/index');
    },
    name: 'Group',
    meta: {
      title: '会员分组',
      icon: ''
    }
  }, {
    path: 'entityCard',
    component: function component() {
      return import('@/views/my-create/Member/entityCard/index');
    },
    name: 'entityCard',
    meta: {
      title: '会员实体卡',
      icon: ''
    }
  }]
};
export default userRouter;